import { LANGUAGES } from '../../../constants/languages';

export const MEDIA = {
  [LANGUAGES.EN]: [
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/instagram_video_cover.jpg',
      link: 'https://www.instagram.com/reel/CtZHuK6tg8z/',
      social: 'https://www.instagram.com/siteground/',
      label: 'translate.growth.instagram.link.text',
      icon: 'play'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/youtube_video_cover.jpg',
      link: 'https://www.youtube.com/watch?v=ckXbDfYyzcw',
      social: 'https://www.youtube.com/@siteground/videos',
      label: 'translate.growth.youtube.link.text',
      icon: 'play'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/fb_video_cover.jpg',
      link: 'https://www.facebook.com/siteground/videos/211228201767796',
      social: 'https://www.facebook.com/siteground/reels/',
      label: 'translate.growth.facebook.link.text',
      icon: 'play'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/tiktok_video_cover_Rumi.jpg',
      link: 'https://www.tiktok.com/@siteground/video/7153692187258080518',
      social: 'https://www.tiktok.com/@siteground',
      label: 'translate.growth.tiktok.link.text',
      icon: 'play'
    }
  ],
  [LANGUAGES.DE]: [
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/DE/DE_socialthumb_01.jpg',
      link: 'https://www.instagram.com/p/CzA95b0N5HW/',
      social: 'https://www.instagram.com/siteground.de/',
      label: 'translate.growth.instagram.link.text',
      icon: 'link'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/DE/DE_socialthumb_02.jpg',
      link: 'https://x.com/SiteGround_DE/status/1714308536572760547?s=20',
      social: 'https://twitter.com/SiteGround_DE',
      label: 'translate.growth.twitter.link.text',
      icon: 'link'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/DE/DE_socialthumb_03.jpg',
      link: 'https://www.facebook.com/reel/1350947712498395',
      social: 'https://www.facebook.com/siteground.de',
      label: 'translate.growth.facebook.link.text',
      icon: 'play'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/DE/DE_socialthumb_04.jpg',
      link: 'https://de.siteground.com/blog/kleinunternehmen-seo/',
      social: 'https://de.siteground.com/blog/',
      label: 'translate.growth.blog.link.text',
      icon: 'link'
    }
  ],

  [LANGUAGES.FR]: [
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/FR/FR_socialthumb_01.jpg',
      link: 'https://www.instagram.com/p/CzWIYmPt-F2/',
      social: 'https://www.instagram.com/siteground.fr/',
      label: 'translate.growth.instagram.link.text',
      icon: 'link'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/FR/FR_socialthumb_02.jpg',
      link: 'https://twitter.com/SiteGround_FR/status/1720110459607474626',
      social: 'https://twitter.com/SiteGround_FR',
      label: 'translate.growth.twitter.link.text',
      icon: 'link'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/FR/FR_socialthumb_03.jpg',
      link: 'https://www.facebook.com/reel/979502536588787',
      social: 'https://www.facebook.com/siteground.fr/',
      label: 'translate.growth.facebook.link.text',
      icon: 'play'
    },
    {
      image: 'https://www.siteground.com/static/en/img/recap2023/FR/FR_socialthumb_04.jpg',
      link: 'https://fr.siteground.com/blog/nouveau-outil-de-marketing-par-e-mail-siteground-pour-stimuler-la-croissance-de-votre-entreprise/',
      social: 'https://fr.siteground.com/blog',
      label: 'translate.growth.blog.link.text',
      icon: 'link'
    }
  ]
};

export const ES_IT_MEDIA = {
  [LANGUAGES.IT]: {
    facebook: {
      link: 'https://www.facebook.com/SiteGround.it',
      label: 'translate.growth.facebook.link.text'
    },
    twitter: {
      link: 'https://twitter.com/siteground_it',
      label: 'translate.growth.twitter.link.text'
    },
    instagram: {
      link: 'https://www.instagram.com/siteground.it/',
      label: 'translate.growth.instagram.link.text'
    },
    youtube: {
      link: 'https://www.youtube.com/@SiteGroundItalia',
      label: 'translate.growth.youtube.link.text'
    }
  },
  [LANGUAGES.ES]: {
    facebook: {
      link: 'https://fb.com/siteground.es',
      label: 'translate.growth.facebook.link.text'
    },
    twitter: {
      link: 'https://twitter.com/siteground_es',
      label: 'translate.growth.twitter.link.text'
    },
    instagram: {
      link: 'https://www.instagram.com/siteground.esp/',
      label: 'translate.growth.instagram.link.text'
    },
    youtube: {
      link: 'https://youtube.com/sitegroundespana/',
      label: 'translate.growth.youtube.link.text'
    }
  }
};
